import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Shipping = () => {
    return (
        <>
            <Header />
            <main className="main">
                {/* Breadcrumb Start */}
                <div className="breadcrumb-wrap" id="breadcrumb-margin">
                  <div className="banner" style={{minHeight:'10px'}}>     
                        <img className="bg-img bg-top" src="assets/images/inner-page/banner-p.html" alt="banner" />

                        <div className="container-lg">
                            <div className="breadcrumb-box">
                                <div className="heading-box">
                                    <h1>Shipping</h1>
                                </div>
                                <ol className="breadcrumb">
                                    <li><a href="/">Home</a></li>
                                    <li>
                                        <a href="javascript:void(0)"><i data-feather="chevron-right"></i></a>
                                    </li>
                                    <li className="current"><a href="">Shipping</a></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Breadcrumb End */}

                {/* Blog Detail Section Start */}
                <section>
                    <div className="container-lg">
                        <div className="row gy-5 g-lg-3 g-xxl-4">
                            <div className="col-lg-12 order-1 order-lg-2 ratio_36">
                                <div className="blog-wrap">
                                    {/* Blog Section Start */}
                                    <div className="blog-box blog-detail">
                                        <div className="content-box">
                                            <span><i data-feather="clock"> </i>Return & Refund Policy</span>
                                            <h5>Domestic orders</h5>
                                            <p>Your request for return and refund will be accepted on the following conditions:</p>
                                            <br />
                                            <p>1. If the product is delivered to you in damaged/defective condition. (unboxing video required)</p>
                                            <p>2. If the wrong item is delivered to you (wrong size or incorrect quantity - unboxing video required).</p>
                                            <p>3. For products to be eligible for return, they must be in the original unused condition. A copy of the purchase receipt is required for the return and refund request to be accepted.</p>
                                            <p>4. Call for return must be raised within 2 days from the date of delivery. Products can be returned within 7 days from the date of delivery only.</p>
                                            <p>5. Return and refund is not applicable for custom orders.</p>
                                            <p>6. In exception cases, if the product doesn't meet your requirement, then return can be accepted but refund is not possible. Instead, an exchange option is available or a gift card for the corresponding amount will be issued, wherein the customer can make purchases anytime upto next 1 year, for the same amount.</p>
                                            <p>7. The shipping charges on returns are to be borne by the customer.</p>
                                            <p>8. Cancellation of orders must be done within 24hrs from the time of order for the customer to be eligible for a refund.</p>
                                            <p>9. In case of partial cancellation, only gift cards can be issued for the specific amount. Refunds are not applicable.</p>
                                            <p>10. Refunds will be processed only after the products are completely examined and approved by our quality control team.</p>
                                            <p>11. Refunds are not applicable for delay in delivery of products.</p>

                                            <h5>International orders</h5>
                                            <p>1. Return policy is not applicable for international orders. Nevertheless, a refund will be issued if the product is delivered in damaged/defective condition only (video required)</p>
                                            <p>2. Call for return must be raised within 2 days from the date of delivery.</p>
                                            <p>3. Only the product cost will be refunded in case you receive damaged or defective items. The shipping cost for damaged products is non-refundable.</p>

                                            <h5>Return and refund process</h5>
                                            <p>1. Kindly raise a request by writing an email with the concerned order details mentioning the correct reason to support@welbeing.com</p>
                                            <p>2. Customers can return the product only post receipt of acceptance message from welbeing.</p>
                                            <p>3. Once the returned product is approved by our quality control team, a refund will be initiated within 7-10 working days through the same mode of payment.</p>
                                        </div>
                                    </div>
                                    {/* Blog Section End */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* Blog Detail Section End */}
            </main>
            <Footer />
        </>
    )
}

export default Shipping;